export const requiredRule = (v) => !!v || 'This field is required!';
export const passwordRule = (v) => (!!v && v.length >= 6) || 'Password must be at least 6 characters.';
